import React from 'react';

const CheckPermiso = (props) => {
    return (
        <div className="checkbox-container">
            <input type="checkbox" checked={props.Checked}
                value={props.Id} data-value={props.Id} key={props.Key}
                id={"Permiso" + props.PermisoId + "-Funcion" + props.Id} onClick={() => props.checkFuncion(props.PermisoId, props.Id, props.Checked)} />
            <label htmlFor={"Permiso" + props.PermisoId + "-Funcion" + props.Id}>{props.Description}</label>
        </div>
    );
}

export default CheckPermiso;